import {
  Card,
  Col,
  Row,
  Form,
  Select,
  Divider,
  Input,
  Button,
  Collapse,
  Switch,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { getUserData } from "../../login/LoginSlice";
import {
  getCorporateName,
  getEndorCalcPolicyType,
  createEndorseRackRates,
} from "../../../Action/Actions";

const { Option } = Select;

const EnrollType = [
  {
    name: "Family Wise",
    id: 1,
  },
  {
    name: "Per Life Wise",
    id: 2,
  },
];

const AddRackRate = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector(getUserData);
  const [CorpName, setCorpName] = useState([]);
  const [CorpId, setCorpId] = useState("");
  const [PolicyNum, setPolicyNum] = useState([]);
  const [PolicyId, setPolicyId] = useState("");
  const [EnrollId, setEnrollId] = useState("");
  const [PolicyType, setPolicyType] = useState("");
  const [PolicyTypeId, setPolicyTypeId] = useState("");
   const AuthData = useSelector(getUserData);
  //   const [sumInsur, setSumInsur] = useState([]);
  //   const [sumInsurForm, setSumInsurForm] = useState([
  //     { id: 1, mandatory: true },
  //   ]);
  const [sumInsur, setSumInsur] = useState([]);
  const [activePanels, setActivePanels] = useState(
    sumInsur?.map((_, i) => `${i + 1}`)
  );
  const [sumInsurForms, setSumInsurForms] = useState({});
  const [loading, setLoading] = useState(false);
  //   const [sumInsurForms, setSumInsurForms] = useState({
  //     [sumInsur.id]: [], // Initially empty input fields
  //   });
  useEffect(() => {
    const initialForms = sumInsur.reduce((acc, item) => {
      acc[item.id] = [{ id: 1, mandatory: true }];
      return acc;
    }, {});
    setSumInsurForms(initialForms);
  }, [sumInsur]);

  //   const [activePanels, setActivePanels] = useState([]);

  //   const toggleCollapse = (index) => {
  //     setSumInsur((prev) =>
  //       prev.map((item, i) =>
  //         i === index ? { ...item, disabled: !item.disabled } : item
  //       )
  //     );
  //   };

  //   const handleCollapseChange = (keys) => {
  //     setActivePanels(keys);
  //   };
  console.log("active pannel", activePanels);
  const toggleCollapse = (index) => {
    setSumInsur((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, disabled: !item.disabled } : item
      )
    );

    setActivePanels((prev) => {
      if (sumInsur[index].disabled) {
        // If enabling (switch ON), only add if the panel is not manually closed
        return [...prev, `${index + 1}`];
      } else {
        // If disabling (switch OFF), always remove the panel
        return prev.filter((key) => key !== `${index + 1}`);
      }
    });
  };

  const handleCollapseChange = (keys) => {
    console.log("keys", keys);
    setActivePanels(keys);
  };
  useEffect(() => {
    document.title = `Add Rack Rate`;
    dispatch(getCorporateName(AuthData?.corporate_id))
      .then((data) => {
        console.log("data", data);
        setCorpName(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [dispatch]);

  const getPolicyType = (id) => {
    console.log("id", id);
    dispatch(getEndorCalcPolicyType(id))
      .then((data) => {
        console.log("data", data);
        const { policy_type } = data;
        setPolicyNum(policy_type);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const OnNameSelect = (id, values) => {
    console.log(id, values);
    setCorpId(values.key);
    getPolicyType(values?.key);
  };
  const OnPolicySelect = (id, values) => {
    console.log(id, values);
    setPolicyId(values.key);
    setPolicyType(values?.policy_type);
    setSumInsur(values?.sum_insured);
    setPolicyTypeId(values?.policy_type_id);
  };
  const OnEnrollSelect = (id, values) => {
    console.log(id, values);
    setEnrollId(values.key);
  };
  const addSumInsur = (panelId) => {
    setSumInsurForms((prevForms) => ({
      ...prevForms,
      [panelId]: [
        ...(prevForms[panelId] || []),
        { id: Date.now(), mandatory: false },
      ],
    }));
  };

  // Remove a field from a specific panel
  const removeSumInsur = (panelId, fieldId) => {
    setSumInsurForms((prevForms) => ({
      ...prevForms,
      [panelId]: prevForms[panelId].filter((field) => field.id !== fieldId),
    }));
  };

  const items = sumInsur?.map((item, index) => ({
    key: `${index + 1}`,
    label: (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Sum Insured: {item.amount}</span>
        <Switch
          style={{ width: "45px" }}
          checked={!item.disabled}
          //   checked={!item.disabled}
          onChange={() => toggleCollapse(index)}
        />
      </div>
    ),
    children: (
      <>
        {sumInsurForms[item.id]?.map((e, idx) => (
          <React.Fragment key={e.id}>
            {idx > 0 && <Divider />}
            <Row gutter={16} className="mb-3">
              <Col xs={24} sm={6} md={6}>
                <Form.Item
                  name={`age_from_${item.id}_${e.id}`}
                  label="Age From"
                  rules={[
                    {
                      required: !item.disabled,
                      message: "Please input Age From!",
                    },
                  ]}
                >
                  <Input type="number" placeholder="Age From" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6} md={6}>
                <Form.Item
                  name={`age_to_${item.id}_${e.id}`}
                  //   name={`age${item.id}_${e.id}_to`}
                  label="Age To"
                  rules={[
                    {
                      required: !item.disabled,
                      message: "Please input Age To!",
                    },
                  ]}
                >
                  <Input type="number" placeholder="Age To" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6} md={6}>
                <Form.Item
                  name={`annual_premium_${item.id}_${e.id}`}
                  label="Annual Premium"
                  rules={[
                    {
                      required: !item.disabled,
                      message: "Please input Annual Premium!",
                    },
                  ]}
                >
                  <Input type="number" placeholder="Annual Premium" />
                </Form.Item>
              </Col>
              {PolicyType === "GPA" && (
                <Col xs={24} sm={6} md={6}>
                  <Form.Item
                    name={`total_rates_in_mile_${item.id}_${e.id}`}
                    label="Total Rate in Mille"
                    rules={[
                      {
                        required: !item.disabled,
                        message: "Please input Total Rate in Mille!",
                      },
                    ]}
                  >
                    <Input type="number" placeholder="Total Rate in Mille" />
                  </Form.Item>
                </Col>
              )}
              {PolicyType === "GMC" && (
                <>
                  {idx === 0 && (
                    <Col
                      xs={24}
                      sm={4}
                      md={4}
                      className="d-flex align-items-center"
                    >
                      <Button
                        className="d-flex"
                        type="primary"
                        onClick={() => addSumInsur(item.id)}
                        icon={<PlusOutlined />}
                      >
                        New Group
                      </Button>
                    </Col>
                  )}
                  {sumInsurForms[item.id]?.length > 1 && idx !== 0 && (
                    <Col
                      xs={24}
                      sm={4}
                      md={4}
                      className="d-flex align-items-center"
                    >
                      <Button
                        className="d-flex"
                        type="primary"
                        danger
                        icon={<MinusCircleOutlined />}
                        onClick={() => removeSumInsur(item.id, e.id)}
                      >
                        Delete
                      </Button>
                    </Col>
                  )}
                </>
              )}
            </Row>
          </React.Fragment>
        ))}
      </>
    ),
    collapsible: item.disabled ? "disabled" : undefined, // Disable only this panel
  }));
  const onFinishFailed = (err) => {
    form.scrollToField(err.errorFields[0].name);
  };

  const onFinish = (values) => {
    console.log("values", values);
    console.log("sumInsur", sumInsur);
    console.log("sumInsurForms", sumInsurForms);
    setLoading(true);
    const formattedData = sumInsur.map((item) => ({
      id: item.id,
      amount: item.amount,
      ages: (sumInsurForms[item.id] || []).map((age) => ({
        age_from: values[`age_from_${item.id}_${age.id}`],
        age_to: values[`age_to_${item.id}_${age.id}`],
        annual_premium: values[`annual_premium_${item.id}_${age.id}`],
        toprate_in_mile: values[`total_rates_in_mile_${item.id}_${age.id}`],
      })),
    }));

    console.log("Final Data Structure:", formattedData);
    const post = {
      corporate_id: CorpId,
      corporate: values?.corporate,
      policy_id: PolicyId,
      policy: values?.policy_no,
      enrollment_type_id: 2,
      enrollment_type: values?.enrollment_type,
      policy_type_id: EnrollId,
      policy_type: PolicyType,
      user_id: userData?.user_id,
      suminsured: formattedData,
    };
    console.log("post", post);
    dispatch(createEndorseRackRates(PolicyTypeId, post))
      .then((data) => {
        console.log("data", data);
        message.success(data?.message);
        setLoading(false);
        navigate("/corporate/Endorsement");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  return (
    <div className="site-card-wrapper">
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span className="corp-title">Rack Rates</span>
              </div>
            }
            bordered={false}
          >
            <Form
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              autoComplete="off"
            >
              <Row gutter={16}>
                <Col xs={24} sm={6}>
                  <Form.Item
                    name="corporate"
                    label="Select Corporate"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Template name!",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Corporate name"
                      // notFoundContent={null}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onSelect={OnNameSelect}
                    >
                      {CorpName?.map((insurer) => (
                        <Option
                          key={insurer.corporate_id}
                          value={insurer.corporate_name}
                        >
                          {insurer.corporate_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6}>
                  <Form.Item
                    name="policy_no"
                    label="Select Policy"
                    rules={[
                      { required: true, message: "Please Select Policy !" },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Policy"
                      // notFoundContent={null}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onSelect={OnPolicySelect}
                    >
                      {PolicyNum?.map((insurer) => (
                        <Option
                          key={insurer.id}
                          value={insurer.policy_number}
                          policy_type={insurer.policy_type}
                          sum_insured={insurer.sum_insureds}
                          policy_type_id={insurer.ref_md_policy_types_id}
                        >
                          {insurer.policy_number}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {PolicyType === "GMC" && (
                  <Col xs={24} sm={6}>
                    <Form.Item
                      name="enrollment_type"
                      label="Select Enrollment Type"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Enrollment Type!",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select Enrollment Type"
                        // notFoundContent={null}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onSelect={OnEnrollSelect}
                      >
                        {EnrollType?.map((enr) => (
                          <Option key={enr.id} value={enr.name}>
                            {enr.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}

                <Collapse
                  className="w-100 custom-collapse"
                  //   defaultActiveKey={["1"]}
                  items={items}
                  activeKey={activePanels} // Prevent unintended opening
                  onChange={handleCollapseChange}
                  //   collapsible={collapseDisabled ? "disabled" : undefined}
                />
                <Col xs={24} sm={24}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="mb-4 mt-4"
                    loading={loading}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
export default AddRackRate;
